<template>
  <div class="leading-none">
    <!-- The HTML #id in tippy has to match the hidden tooltip below (.product.id used as example) -->
    <span
      v-cloak
      v-tippy="{
        html: '#pricing-tooltip',
        theme: 'light-gray',
        placement: 'bottom',
      }"
      :class="{hidden: !displayTooltip}"
      class="b2b-buying-zone__price-info"
      qaid="buying-zone.price-info"
    >
      <i class="material-icons">info</i>
    </span>

    <!-- Pricing Tooltip -->
    <div id="pricing-tooltip" v-tippy-html class="hidden">
      <div v-if="priceInfo" class="b2b-buying-zone__tooltip min-w-xs font-bold">
        <div class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('originalPrice')"></div>
          <div class="pl-4">{{ priceInfo.wasPrice }}</div>
        </div>
        <div v-if="priceInfo.advancedOrderPrice" class="flex justify-between pt-1">
          <div class="font-normal">{{ bp('advancedOrderPrice') }}</div>
          <div class="pl-4">{{ priceInfo.advancedOrderPrice }}</div>
        </div>
        <div v-if="priceInfo.price && priceInfo.price !== priceInfo.wasPrice" class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('salePrice')"></div>
          <div class="pl-4">{{ priceInfo.price }}</div>
        </div>
        <div
          v-for="(bulkPrice, index) in getProcessedBulkPrices(priceInfo.bulkPrices)"
          :key="index"
          class="flex justify-between pt-1"
        >
          <div class="font-normal">
            <span v-if="index === 0" v-html="bp('bulkPrice')"></span>
          </div>
          <div class="pl-4">{{ bulkPrice }}</div>
        </div>
        <div
          v-for="(bulkSalePrice, index) in getProcessedBulkPrices(priceInfo.bulkSalePrices)"
          :key="index"
          class="flex justify-between pt-1"
        >
          <div class="font-normal">
            <span v-if="index === 0" v-html="bp('bulkSalePrice')"></span>
          </div>
          <div class="pl-4">{{ bulkSalePrice }}</div>
        </div>
        <div v-if="priceInfo.savedAmount" class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('youSave')"></div>
          <div class="pl-4 text-alert">{{ priceInfo.savedAmount }}</div>
        </div>
        <hr class="border-gray-20 my-2" />
        <div v-if="priceInfo.calculableAdvertised" class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('advertised')"></div>
          <div class="pl-4">{{ priceInfo.calculableAdvertised }}</div>
        </div>
        <div v-if="priceInfo.calculableSaleAdvertised" class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('sale')"></div>
          <div class="pl-4">{{ priceInfo.calculableSaleAdvertised }}</div>
        </div>
        <div v-if="priceInfo.applePrice" class="flex justify-between pt-1">
          <div class="font-normal" v-html="bp('applePrice')"></div>
          <div class="pl-4">{{ priceInfo.applePrice }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import findIndex from 'lodash/findIndex';
import {mapState} from 'vuex';

export default {
  data() {
    return {
      priceInfo: null,
      lastProductId: null,
      displayTooltip: false,
    };
  },

  computed: {
    ...mapState('pdp', ['pdpSku']),
  },

  watch: {
    pdpSku() {
      if (this.lastProductId !== this.pdpSku) {
        this.retrievePricingInfo(this.pdpSku);
      }
    },
  },

  created() {
    let productId = this.getProductIdFromUrl();

    if (productId) {
      this.retrievePricingInfo(productId);
    }
  },

  methods: {
    retrievePricingInfo(productId) {
      this.lastProductId = productId;
      axios.get('/p/pricinginfo/' + productId + '/').then(({data}) => {
        if (data && data.price) {
          this.priceInfo = data;
          this.displayTooltip = true;
        } else {
          this.priceInfo = null;
          this.displayTooltip = false;
        }

        if (data && data.vendorMinQty) {
          this.$emit('min-qty-change', data.vendorMinQty);
        } else {
          this.$emit('min-qty-change', null);
        }
      });
    },

    getProductIdFromUrl() {
      let pathArray = window.location.pathname.split('/');
      let index = findIndex(pathArray, (x) => x == 'p');

      if (index > -1 && pathArray.length > index + 1) {
        return pathArray[index + 1];
      }

      return null;
    },

    getProcessedBulkPrices(bulkPrices) {
      let result = [];

      if (bulkPrices && bulkPrices.length) {
        bulkPrices.forEach(function(bulkPrice) {
          result.push(
            bulkPrice.minBulkPriceRangeQty + '-' + bulkPrice.maxBulkPriceRangeQty + ' = ' + bulkPrice.bulkRangePrice
          );
        });
      }

      return result;
    },
  },
};
</script>
